import React from "react";
const IntGoogle = () => {
  return <div>IntGoogle</div>;
};
export default IntGoogle;
